export default __webpack_public_path__ + "static/media/shubham_profile.43307a5d.png";